/* global I18n */

import React from "react"
import {Doughnut} from "react-chartjs-2"
import "chart.js/auto"

function DoughnutChart({data_set, label, single_tooltip}) {
  const data = get_data(data_set, label)
  const options = get_options(single_tooltip)

  return (
    <div className="colored-doughnut"
         style={{width: "100%", height: "100%", position: "relative"}}>
      <div style={{
        pointerEvents: "none",
        position: "absolute",
        width: "100%",
        height: "100%"
      }}>
        <Doughnut data={data_background} options={options_background}/>
      </div>
      <div style={{position: "absolute", width: "100%", height: "100%"}}>
        <Doughnut data={data} options={options}/>
      </div>
    </div>
  )
}

export default DoughnutChart

// We make a grey doughnut behind the colored one, to achieve the look we want
const data_background = {
  datasets: [{
    data: [1], // Full circle
    backgroundColor: ["#F7F7F7"],
    borderWidth: 0
  }]
}

const options_background = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "70%",
  rotation: 0,
  circumference: 360,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      enabled: false
    }
  }
}

function get_data(data_set, label) {
  const undiscovered = I18n.t("js.new_embedded_quiz.study_summary.undiscovered")
  const learning = I18n.t("js.new_embedded_quiz.study_summary.learning")
  const mastering = I18n.t("js.new_embedded_quiz.study_summary.mastering")
  const mastery = I18n.t("js.new_embedded_quiz.study_summary.mastery")

  return {
    labels: [learning, mastering, mastery, undiscovered],
    datasets: [{
      label: label,
      data: data_set, // order: learning, mastering, mastery, undiscovered
      backgroundColor: ["#99D6FF", "#0099FF", "#FFC026", "#F7F7F7"],
      hoverBackgroundColor: ["#99D6FF", "#0099FF", "#FFC026", "#F7F7F7"],
      borderWidth: 1,
      hoverBorderWidth: 1,
      borderColor: "#F7F7F7",
      hoverBorderColor: "#F7F7F7",
      borderRadius: 10
    }]
  }
}

function get_options(single_tooltip) {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: single_tooltip ? {enabled: false} : tooltip_options
    },
    elements: {
      arc: {
        hoverBorderWidth: 0 // Ensure no hover border effect
      }
    },
    cutout: "70%", // This makes the chart a doughnut chart
    rotation: 0, // Start angle of the first segment
    circumference: 360 // Sweep angle of the chart
  }
}

const tooltip_options =
  {
    enabled: true,
    backgroundColor: "#3A5062",
    bodyFont: {
      size: 12,
      family: "'PlutoSansMedium', 'Helvetica', 'Arial', sans-serif",
      weight: "normal",
      color: "#fff"
    },
    callbacks: {
      title: () => "",
      label: (context) => {
        const label = context.label || ""
        const value = context.raw || 0
        return `${value}% ${label}`
      }
    },
    displayColors: false,
    cornerRadius: 3,
    padding: 10,
    position: "nearest"
  }
